import { formatMinSecTenth, parseMinSec } from "./operations";

export type RangeCheck =
  | { ok: true; start: number; end: number; /** True when a typed end past the audio's length was pulled back to the length. */ clamped: boolean }
  | { ok: false; message: string };

/**
 * Checks a start and end typed as text ("1:23", "83", "1:23.5") against the length of the audio. A message is
 * returned for anything the tool cannot act on, so the field can say so and stay as typed; an end past the
 * length is pulled back to it.
 */
export function checkRange(startText: string, endText: string, durationSeconds: number): RangeCheck {
  const start = parseMinSec(startText);
  const end = parseMinSec(endText);
  if (start === null || end === null) return { ok: false, message: "Type each time as minutes:seconds, for example 1:23 or 83." };
  if (start < 0 || end < 0) return { ok: false, message: "Times cannot be negative." };
  if (durationSeconds > 0 && start >= durationSeconds) return { ok: false, message: `The start (${formatMinSecTenth(start)}) is past the end of the audio, which is ${formatMinSecTenth(durationSeconds)} long.` };
  if (end <= start) return { ok: false, message: `The end (${formatMinSecTenth(end)}) must be after the start (${formatMinSecTenth(start)}). Nothing was changed.` };
  const clamped = durationSeconds > 0 && end > durationSeconds;
  return { ok: true, start, end: clamped ? durationSeconds : end, clamped };
}
